import s from "../../pages/info-page/styles.module.css";

export const DeletedUsersIcon = ({ styleSVG }) => {
  return (
    <svg className={s[`${styleSVG}`]} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_3337_3789)">
        <path d="M16.3027 21V19C16.3027 17.9391 15.8813 16.9217 15.1312 16.1716C14.381 15.4214 13.3636 15 12.3027 15H5.30273C4.24187 15 3.22445 15.4214 2.47431 16.1716C1.72416 16.9217 1.30273 17.9391 1.30273 19V21" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.80273 11C11.0119 11 12.8027 9.20914 12.8027 7C12.8027 4.79086 11.0119 3 8.80273 3C6.5936 3 4.80273 4.79086 4.80273 7C4.80273 9.20914 6.5936 11 8.80273 11Z" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18.3027 8L23.3027 13" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M23.3027 8L18.3027 13" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_3337_3789">
          <rect width="24" height="24" fill="white" transform="translate(0.302734)"/>
        </clipPath>
      </defs>
    </svg>
  );
}

